import * as units from './units';
import * as settings from './settings';

export class inputValidation {
  // cTyped is the last character the user wrote on the input
  static fixDmmLat(str: string, cTyped?: string): string {
    // if the string is empty let the user type something and completet the rest of the mask for him
    if (cTyped && str == "") {
      if (cTyped == '-') {
        return "S " + units.DEGREE_CHAR;
      }
      else if (parseInt(cTyped) || cTyped == '0') {
        return "N " + cTyped + "" + units.DEGREE_CHAR;
      }
    }

    let strarr = str.split(' ');
    // means the field came empty
    if (strarr.length < 2) {
      return str;
    }

    // seperate the string
    let start: string = strarr[0];
    let mid: string = strarr[1];
    if (str.includes(units.DEGREE_CHAR)) {
      mid = mid.replace(units.DEGREE_CHAR, '');
    }

    start = this.plusMinusFixLat(start, cTyped);

    // add '.' if value exceeds max
    // This is a fix incase user types 0 at the start
    let addr = 0;
    if (mid[0] == '0') { addr = 1 }
    // if (parseFloat(mid) > 90 && !mid.includes('.')) {
    if (parseInt(mid) > 89) {
      let chek: number = parseInt(mid) / 10;
      if (chek > 9 && chek < 10) {
        mid = this.addChar(mid, 1 + addr, '.');
      } else if (mid[0] == '9' && mid[1] == '0') {
        mid = "90";
      } else {
        mid = this.addChar(mid, 2 + addr, '.');
      }
      mid = this.fixPoints(mid);
      // remove 0 if there are 3 numbers before .
      if (mid[4] == '.') {
        mid = this.replaceChar(mid, 0, '');
      }
    }
    else {
      mid = this.fixPoints(mid);
    }

    return start + " " + mid + units.DEGREE_CHAR;
  }

  static fixDmmLong(str: string, cTyped?: string): string {
    // if the string is empty let the user type something and completet the rest of the mask for him
    if (cTyped && str == "") {
      if (cTyped == '-') {
        return "W " + units.DEGREE_CHAR;
      }
      else if (parseInt(cTyped) || cTyped == '0') {
        return "E " + cTyped + "" + units.DEGREE_CHAR;
      }
    }

    let strarr = str.split(' ');
    // means the field came empty
    if (strarr.length < 2) {
      return str;
    }

    // seperate the string
    let start: string = strarr[0];
    let mid: string = strarr[1];
    if (str.includes(units.DEGREE_CHAR)) {
      mid = mid.replace(units.DEGREE_CHAR, '');
    }

    start = this.plusMinusFixLong(start, cTyped);

    // add '.' if value exceeds max
    if (parseFloat(mid) > 179) {
      // This is a fix incase user types 0 at the start
      let addr = 0;
      if (mid[0] == '0') { addr = 1 }

      let num = parseFloat(mid) / 10;
      if (num > 100)
        if (num > 180) { mid = this.addChar(mid, 2 + addr, '.'); }
        else if (mid[0] == '1' && mid[1] == '8' && mid[2] == '0') { mid = "180"; }
        else { mid = this.addChar(mid, 3 + addr, '.'); }
      else
        mid = this.addChar(mid, 2 + addr, '.');
    }

    mid = this.fixPoints(mid);
    return start + " " + mid + units.DEGREE_CHAR;
  }

  static fixDmsLat(str: string, cTyped?: string): string {
    // if the string is empty let the user type something and completet the rest of the mask for him
    if (cTyped && str == "") {
      if (cTyped == '-') {
        return "S " + units.DEGREE_CHAR;
      }
      else if (parseInt(cTyped)) {
        return "N " + cTyped + "" + units.DEGREE_CHAR;
      }
    }

    str = this.plusMinusFixLat(str, cTyped);

    return str;
  }

  static fixDmsLong(str: string, cTyped?: string): string {
    // if the string is empty let the user type something and completet the rest of the mask for him
    if (cTyped && str == "") {
      if (cTyped == '-') {
        return "W " + units.DEGREE_CHAR;
      }
      else if (parseInt(cTyped)) {
        return "E " + cTyped + "" + units.DEGREE_CHAR;
      }
    }

    str = this.plusMinusFixLong(str, cTyped);

    return str;
  }

  static fixAltitude(str: string, unit: settings.DisplayUnits, cTyped?: string): string {
    str = this.fixPoints(str);

    // // HFT
    // if (unit == settings.DisplayUnits.Imperial) {
    //   if (parseFloat(str) > settings.MAX_ALT_HFT)
    //     str = settings.MAX_ALT_HFT.toString();
    // }

    // // KM
    // if (unit == settings.DisplayUnits.Metric) {
    //   let maxaltmtr = (settings.MAX_ALT_HFT * 0.1 * units.FEET_TO_METER)
    //   if (parseFloat(str) > maxaltmtr)
    //     str = maxaltmtr.toString();
    // }
    return str;
  }

  static fixSpeed(str: string, unit: settings.DisplayUnits, cTyped?: string): string {
    str = this.fixPoints(str);

    // // HFT
    // if (unit == settings.DisplayUnits.Imperial) {
    //   if (parseFloat(str) > settings.MAX_SPEED_KNOTS)
    //     str = settings.MAX_SPEED_KNOTS.toString();
    // }

    // // KM
    // if (unit == settings.DisplayUnits.Metric) {
    //   let maxspdms = (settings.MAX_SPEED_KNOTS * units.KNOT_TO_METER_SEC)
    //   if (parseFloat(str) > maxspdms)
    //     str = maxspdms.toString();
    // }
    return str;
  }

  static fixHeading(str: string, cTyped?: string): string {
    str = this.fixPoints(str);

    // if (parseFloat(str) > 360)
    //   str = '360';

    return str;
  }


  // WIP!!!
  // static fixCredibility(str: string){
  //   // remove all minuses
  //   str = this.fixMinus(str);

  //   // value is 0-3
  //   let num = parseFloat(str);


  //   // only one digit after period
  // }

  static plusMinusFixLat(str: string, cTyped: string) {
    if (cTyped) {
      if (cTyped == '+') {
        return this.replaceChar(str, 0, 'N');
      }
      if (cTyped == '-') {
        return this.replaceChar(str, 0, 'S');
      }
    }
    return str;
  }

  static plusMinusFixLong(str: string, cTyped: string): string {
    if (cTyped) {
      if (cTyped == '+') {
        return this.replaceChar(str, 0, 'E');
      }
      if (cTyped == '-') {
        return this.replaceChar(str, 0, 'W');
      }
    }
    return str;
  }

  static replaceChar(str: string, index: number, rep: string) {
    let add: number = 0;
    if (rep == "") { add = 1 }
    return (
      str.slice(0, index) +
      rep +
      str.slice(index + rep.length + add)
    );
  }

  static addChar(str: string, index: number, addition: string) {
    return (
      str.slice(0, index) +
      addition +
      str.slice(index)
    );
  }

  static fixPoints(number: string): string {
    let str: string = number;

    // if number starts with point remove it...
    while (str[0] == '.') {
      str = this.replaceChar(str, 0, '');
    }

    let split = str.split('.');
    // no points... or one point not at the start... move on
    if (split.length <= 2) {
      return str;
    }
    else // more than 1 point lets start replacing from end to begining -1 
    {
      for (let i = 2; i < split.length; i++) {
        str = this.replaceChar(str, str.lastIndexOf('.'), '');
      }
    }
    return str;
  }

  static fixMinus(number: string): string {
    let str: string = number;

    // if number starts with - remove it...
    while (str[0] == '-') {
      str = this.replaceChar(str, 0, '');
    }

    let split = str.split('-');
    // no points... or one - not at the start... move on
    if (split.length <= 2) {
      return str;
    }
    else // more than 1 - lets start replacing from end to begining -1 
    {
      for (let i = 2; i < split.length; i++) {
        str = this.replaceChar(str, str.lastIndexOf('-'), '');
      }
    }
    return str;
  }
}